export function parseJSON<T>(json: string): T
export function parseJSON<T>(json: string | null | undefined): T | undefined
export function parseJSON(json: string | null | undefined): unknown {
  return json ? JSON.parse(json) : undefined
}
